import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'

const Modal = ({
  isOpen,
  onClose,
  onAccept,
  title,
  children,
  acceptText = 'Accept',
  closeText = 'Close',
  showScrollToTop = true,
  maxWidth = '1000px',
}) => {
  const contentRef = useRef(null)
  const { t } = useTranslation()
  // Handle escape key
  useEffect(() => {
    const handleEscape = e => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, onClose])

  // Scroll to top function
  const scrollToTop = () => {
    if (contentRef.current) {
      contentRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
  }

  if (!isOpen) return null

  return ReactDOM.createPortal(
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal-content' onClick={e => e.stopPropagation()} style={{ maxWidth }}>
        {/* Modal Header */}
        <div className='modal-header'>
          <h2 className='modal-title'>{title}</h2>
          <button className='modal-close-btn' onClick={onClose} aria-label='Close modal'>
            <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M18 6L6 18M6 6L18 18' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div className='modal-body' ref={contentRef}>
          {children}
        </div>

        {/* Modal Footer */}
        <div className='modal-footer'>
          {showScrollToTop && (
            <button className='modal-scroll-top-btn' onClick={scrollToTop}>
              <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
                <path d='M18 15L12 9L6 15' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
              {t('scroll_top')}
            </button>
          )}

          <div className='modal-action-buttons'>
            <button className='modal-btn modal-btn-secondary' onClick={onClose}>
              {closeText}
            </button>
            {onAccept && (
              <button className='modal-btn modal-btn-primary' onClick={onAccept}>
                {acceptText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default Modal
